var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLightOffSolid = function SvgLightOffSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25 9.5a6.744 6.744 0 0 0 3 5.613V18A2.75 2.75 0 0 0 11 20.75h2A2.75 2.75 0 0 0 15.75 18v-2.887A6.75 6.75 0 1 0 5.25 9.5Zm4.5 7.25v-1.303h4.5v1.303h-4.5Zm1.25 2.5a1.25 1.25 0 0 1-1.225-1h4.45c-.116.57-.62 1-1.225 1h-2Z",
    fill: "currentColor"
  })));
};
export default SvgLightOffSolid;